export default {
  name: "SvgIcon",
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: "1em"
    }
  },
  computed: {
    iconSize() {
      return typeof this.size === "number" ? `${this.size}px` : this.size;
    },
    iconName() {
      // console.log(`#icon-${this.name}`)
      return `#icon-${this.name}`;
    }
  }
};